import { useState } from "react"
import "./AddTask.css"
const AddTask = ({ onSubmit }) => {
  const [addTask, setAddTask] = useState({
    title: "",
    codeLanguage: [],
    status: ""
  })

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!addTask.title.trim()) return
    onSubmit(addTask)
    setAddTask({
      title: "",
      codeLanguage: [],
      status: ""
  })
}

  const langButton = (value) =>{
    if(addTask.codeLanguage.includes(value)) {
      setAddTask({
        ...addTask, codeLanguage: [...addTask.codeLanguage.filter((e) => e !== value)]
      })
      return
    }

    setAddTask({
      ...addTask, codeLanguage: [...addTask.codeLanguage, value]
    })
  }


  return (
    <form className="addTask" onSubmit={handleSubmit}>
      <div className="inputAndStatus" >
        <div className="inputAndLanguages">
          <input
          type="text"
          value={addTask.title}
          onChange={e => setAddTask({...addTask, title: e.target.value})}
          required
          />
          <div>
            <button 
              onClick={() => langButton("HTML")}
              className= {`html ${addTask.codeLanguage.includes("HTML") ? "active" : ""}`}
              >HTML</button>
            <button 
              onClick={() => langButton("CSS")}
              className= {`css ${addTask.codeLanguage.includes("CSS") ? "active" : ""}`}>
              CSS</button>
            <button 
              onClick={() => langButton("JAVASCRIPT")}
              className= {`javascript ${addTask.codeLanguage.includes("JAVASCRIPT") ? "active" : ""}`}>JAVASCRIPT</button>
            <button 
              onClick={() => langButton("REACT")}
              className= {`react ${addTask.codeLanguage.includes("REACT") ? "active" : ""}`}>REACT</button>
            </div>
        </div>
        <select
          value={addTask.status}
          onChange={e =>
            setAddTask({...addTask, status: e.target.value })
          }
          className={addTask.status}
          required>
          <option value={""} style={{background: "white"}}>Select Status</option>
          <option value={"todo"} style={{background: "#B60703"}}>To Do</option>
          <option value={"pending"} style={{background: "#BB7F34"}}>Pending</option>
          <option value={"finish"} style={{background: "#187B1B"}}>Finish</option>
        </select>
      </div>
      <button className="addBtn" type="submit">Add Task</button>
    </form>
  )
}

export default AddTask